// extracted by mini-css-extract-plugin
export default {"listItem":"SelectInput_listItem__SCbXP","selectArrow":"SelectInput_selectArrow__5CNP5"};